import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCreditNote, deleteCreditNote, fetchCreditNotes, updateCreditNote } from "../../../slices/company/creditNotesSlice";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Delete, Pen } from "lucide-react";
import Swal from "sweetalert2";
import CreditNoteForm from "./credit_note_form";
import { fetchBills } from "../../../slices/company/billsSlice";
import moment from "moment";
import { customTableStyles } from "../../../utils/tableStylings";

const CreditNotes = () => {
    const [modalShow, setModalShow] = useState(false);
    const [editData, setEditData] = useState(null);
    const dispatch = useDispatch();
    const { creditNotes, loading, error } = useSelector((state) => state.creditNotes);
    const { bills } = useSelector((state) => state.bills);


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            dispatch(fetchBills(company.company?.id));
        }
    }, [dispatch]);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem("company"));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchCreditNotes(companyId));
        }
    }, [dispatch]);

    // Handle add new credit note
    const handleAddNew = () => {
        setEditData(null); // Reset edit data
        setModalShow(true);
    };

    // Handle edit credit note
    const handleEdit = (creditNote) => {
        setEditData(creditNote);
        setModalShow(true);
    };

    // Handle delete credit note
    const handleDelete = (creditNoteId) => {
        Swal.fire({
            title: "<strong>Are you sure?</strong>",
            html: `<p>This action will <b>permanently delete</b> this Credit Note.</p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteCreditNote(creditNoteId));
                Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: "The Credit Note has been deleted.",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                });
            }
        });
    };

    // Handle form submission
    const handleSubmit = (formData) => {
        // console.log("Submitted Data:", formData);
        if (editData && editData?.id != null) {
            dispatch(updateCreditNote({ id: editData.id, updatedData: formData }));

        } else {
            
            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company.company?.id;
            const newFormData = { ...formData, company_id: companyId };
            dispatch(addCreditNote(newFormData));
        }
        setModalShow(false);
    };

    // Define table columns
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "50px",
        },
        {
            name: "Customer",
            cell: (row) => (
                <div className="">
                    <strong>{row.Bills?.Customer?.name}</strong><br />
                    <small>{row.Bills?.Customer?.company_name}</small>
                </div>
            ),
            sortable: true,
        },
        {
            name: "Invoice",
            selector: (row) => row.Bills?.bill_number,
            sortable: true,
        },
        {
            name: "Order Number",
            selector: (row) => row.Bills?.order_number,
            sortable: true,
        },
        {
            name: "Date",
            selector: (row) => moment(row.date).format('DD MMMM, YYYY'),
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            sortable: true,
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div>
                    <button
                        className="text-success me-2 border-0 bg-transparent"
                        onClick={() => handleEdit(row)}
                    >
                        <Pen />
                    </button>
                    <button
                        className="text-danger border-0 bg-transparent"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title">Credit Notes</h4>
                            <button type="button" onClick={handleAddNew} className="btn btn-primary">
                                Add New
                            </button>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <DataTable
                                    className="table-hover custom-table"
                                    columns={columns}
                                    data={creditNotes}
                                    pagination
                                    striped
                                    progressPending={loading}
                                    customStyles={customTableStyles}
                                />
                            </div>
                            {error && <p className="text-danger mt-2">Error: {error}</p>}
                        </div>
                    </div>
                </div>

                
            </div>
            <CreditNoteForm
                show={modalShow}
                onClose={() => setModalShow(false)}
                heading={editData ? "Edit Credit Note" : "Add Credit Note"}
                initialData={editData || {}}
                billsData={bills}
                onSubmit={handleSubmit}
            />
        </>
    );
};

export default CreditNotes;
